import { Button, Center, Divider, Flex, Grid, Loader, Modal, MultiSelect, Select, Stack, Text, TextInput } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../../contexts/AppContext";
import { COUNTRY_LIST } from "../../../utils/country-list";
import PhoneInputField from "../../../components/PhoneInputField/PhoneInputField";
import { IconEye, IconPhone, IconSchool } from "@tabler/icons-react";
import { DateInput } from "@mantine/dates";
import { LEADS_CAMPAIGN, LEADS_METHODS, LEADS_OUTCOME, LEADS_TYPES } from "../../../utils/leads-constant";
import axios from "axios";
import AuthContext from "../../../contexts/AuthContext";
import showNotification from "../../../utils/showNotification";


const contactAttemptsInitialValuesItem = {
    date: new Date(),
    campaign: LEADS_CAMPAIGN[0],
    method: LEADS_METHODS[0],
    outcome: LEADS_OUTCOME[0].value,
    no_reason: '',
    seller_id: "",
    comment: "",
}

const notesInitialValues = {
    note: "",
    date: new Date(),
}


export default function SalesLeadsForm(props) {
    const { staffUsers, academicUnits } = useContext(AppContext)
    const { authToken } = useContext(AuthContext)
    const { form, loading } = props;


    const handleAddItem = (form_path, initialValues, index = 0) => {
        if (!Array.isArray(form.values[form_path])) {
            form.setFieldValue(form_path, []);
        }

        form.insertListItem(form_path, initialValues, index);
    };

    const handleRemoveItem = (form_path, index) => {
        form.removeListItem(form_path, index);
    };

    const [isLeadLoading, setIsLeadLoading] = useState(false)

    useEffect(() => {
        const leadId = form.values._id
        if (!leadId) return

        const getLeadById = async () => {

            try {
                setIsLeadLoading(true)
                const URL = `${process.env.REACT_APP_BACKEND_SERVER}admin/ventas/leads?leadId=${leadId}`
                const axiosConfig = {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`
                    }
                };
                const { data } = await axios.get(URL, axiosConfig)
                if (data) {

                    const sortByDateDesc = (a, b) => new Date(b.date) - new Date(a.date);
                    const sortedContacts = (data.contactAttempts || []).sort(sortByDateDesc);

                    form.setFieldValue('contactAttempts', sortedContacts);
                    form.setFieldValue('name', data.name)
                    form.setFieldValue('lastname', data.lastname)
                    form.setFieldValue('username', data.username)
                    form.setFieldValue('country', data.country)
                    form.setFieldValue('lead_type', data.lead_type)
                    form.setFieldValue('lead_type_custom', data.lead_type_custom)
                    form.setFieldValue('interestAreas', data.interestAreas)
                    form.setFieldValue('lead_source', data.lead_source)
                    form.setFieldValue('notes', data.notes || [])
                    form.setFieldValue('status', data.status || '')
                    form.setFieldValue('convertedToUser', data.convertedToUser)
                }
            } catch (error) {
                showNotification({
                    status: 'error',
                    color: 'red',
                    title: "Ha ocurrio un error",
                    message: error?.error || "No se ha podido encontrar el prospecto"
                })
            } finally {
                setIsLeadLoading(false)
            }
        }
        getLeadById()
    }, [form.values._id])

    if (isLeadLoading) return <Stack mih='80vh' align="center" pt={50}>
        <Loader />
        <Text>Cargando prospecto...</Text>
    </Stack>

    return (
        <Grid style={{ width: "100%" }} justify="center" align="center">

            {form.values?.convertedToUser?.userId &&
                <>
                    <Grid.Col span={12}>
                        <Divider label="Información general" labelPosition="center" />
                    </Grid.Col>
                    <Grid.Col span={12}>

                        <Center>
                            <span
                                style={{
                                    fontSize: "var(--fs-body)",
                                    padding: ".5rem .8rem",
                                    textTransform: "uppercase",
                                    borderRadius: "var(--border-radius-sm)",
                                    backgroundColor: "var(--color-green)",
                                    color: '#fff',
                                }}
                            >Ya es alumno</span>
                        </Center>
                    </Grid.Col>
                </>
            }




            <Grid.Col span={12}>
                <Divider label="Datos personales" labelPosition="center" />
            </Grid.Col>



            <Grid.Col span={4}>
                <TextInput
                    {...form.getInputProps("name")}
                    label="Nombre"
                />
            </Grid.Col>
            <Grid.Col span={4}>
                <TextInput
                    {...form.getInputProps("lastname")}
                    label="Apellido"
                />
            </Grid.Col>
            <Grid.Col span={4}>
                <TextInput
                    {...form.getInputProps("username")}
                    label="Nombre de usuario en redes"
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <TextInput
                    {...form.getInputProps("email")}
                    label="Email"
                />
            </Grid.Col>

            <Grid.Col span={6}>
                < PhoneInputField
                    disabled={loading}
                    leftSection={<IconPhone />}
                    {...form.getInputProps("phone")}
                    placeholder="3446544456"
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <Select
                    searchable
                    data={COUNTRY_LIST}
                    {...form.getInputProps("country")}
                    label="País"
                />
            </Grid.Col>

            <Grid.Col span={form?.values?.lead_type?.toUpperCase() === 'OTRO' ? 4 : 12}>
                <Select
                    {...form.getInputProps("lead_type")}
                    withAsterisk
                    label="Tipo"
                    searchable
                    data={LEADS_TYPES}
                />
            </Grid.Col>
            {form?.values?.lead_type?.toUpperCase() === 'OTRO' && <Grid.Col span={8}>
                <TextInput
                    {...form.getInputProps("lead_type_custom")}
                    label="Tipo personalizado"
                />
            </Grid.Col>}

            <Grid.Col span={12}>
                <Divider label="Notas y comentarios" labelPosition="center" />
            </Grid.Col>

            <Grid.Col span={12}>
                <Flex justify="start" gap={12} align="center" mb="sm">
                    <h4 style={{ fontSize: 'var(--fs-body)' }}>Notas</h4>
                    <Button size="xs" variant="light" onClick={() => handleAddItem("notes", notesInitialValues)}>
                        + Agregar ítem
                    </Button>
                </Flex>
                {form.values.notes?.length === 0 && <p style={{ fontSize: "var(--fs-body)" }}>Haz click en el botón agregar item </p>}

                {form.values.notes?.map((item, index) => (
                    <Flex w='100%' align='end' gap={12} mb={12} p={8} style={{
                        background: 'var(--color-base-light)',
                        borderRadius: 'var(--border-radius-sm)',
                        boxShadow: 'var(--box-shadow-md)'
                    }}>
                        <TextInput
                            label="Texto"
                            style={{ flex: 1 }}
                            {...form.getInputProps(`notes.${index}.note`)}
                        />
                        <DateInput
                            {...form.getInputProps(`notes.${index}.date`)}
                            style={{ flex: 1 }}
                            value={
                                form.values.notes[index].date
                                    ? new Date(form.values.notes[index].date)
                                    : null
                            }
                            onChange={(value) =>
                                form.setFieldValue(`notes.${index}.date`, value)
                            }
                            label="Fecha"
                            placeholder="Seleccionar fecha"
                        />
                        <Button
                            type="button"
                            color="red"
                            variant='outline'
                            onClick={() => handleRemoveItem('notes', index)}
                        >
                            Eliminar
                        </Button>
                    </Flex>
                ))}

            </Grid.Col>

            <Grid.Col span={12}>
                <Divider label="Contactos realizados" labelPosition="center" />
            </Grid.Col>


            <Grid.Col span={12}>
                <Flex justify="start" gap={12} align="center" mb="sm">
                    <h4 style={{ fontSize: 'var(--fs-body)' }}>Contactos realizados</h4>
                    <Button size="xs" variant="light"
                        onClick={() => {

                            const lastAttempt = form.values.contactAttempts?.[0];

                            const previousSubject = Array.isArray(lastAttempt?.subject)
                                ? [...lastAttempt.subject]
                                : [];

                            handleAddItem(
                                "contactAttempts",
                                {
                                    ...contactAttemptsInitialValuesItem,
                                    subject: previousSubject
                                }
                            );
                        }}
                    >
                        + Agregar ítem
                    </Button>
                </Flex>
                {form.values.contactAttempts?.length === 0 && <p style={{ fontSize: "var(--fs-body)" }}>Haz click en el botón agregar item</p>}
                {form.values.contactAttempts?.map((item, index) => (

                    <Grid w='100%' p={8} mb={12} style={{
                        background: 'var(--color-base-light)',
                        borderRadius: 'var(--border-radius-sm)',
                        boxShadow: 'var(--box-shadow-md)',

                    }}>

                        <Grid.Col span={{ base: 8, sm: 10 }}>
                            <h3 style={{ fontSize: "var(--fs-h3)", textAlign: 'left', fontWeight: 400 }}>Interacción {index + 1}</h3>
                        </Grid.Col>
                        <Grid.Col span={{ base: 4, sm: 2 }} style={{ alignSelf: 'flex-end' }}>
                            <Button
                                w='100%'
                                type="button"
                                color="red"
                                variant='outline'
                                onClick={() => handleRemoveItem('contactAttempts', index)}
                            >
                                Eliminar
                            </Button>
                        </Grid.Col>

                        <Grid.Col span={{ base: 12, sm: 6 }}>

                            <DateInput
                                {...form.getInputProps(`contactAttempts.${index}.date`)}
                                value={
                                    form.values.contactAttempts[index].date
                                        ? new Date(form.values.contactAttempts[index].date)
                                        : null
                                }
                                onChange={(value) =>
                                    form.setFieldValue(`contactAttempts.${index}.date`, value)
                                }
                                label="Fecha"
                                placeholder="Seleccionar fecha"
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <Select
                                {...form.getInputProps(`contactAttempts.${index}.seller_id`)}
                                withAsterisk
                                label="Vendedor a cargo"
                                searchable
                                data={staffUsers?.filter(item => item?.roles?.includes('ventas'))}
                                onChange={(value) => {
                                    form.setFieldValue(`contactAttempts.${index}.seller_id`, value);
                                }}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 4 }}>
                            <Select
                                data={LEADS_CAMPAIGN}
                                label="Forma de contacto"
                                {...form.getInputProps(`contactAttempts.${index}.campaign`)}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 4 }}>
                            <Select
                                data={LEADS_METHODS}
                                label="Canal"
                                {...form.getInputProps(`contactAttempts.${index}.method`)}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 4 }} style={{ alignSelf: 'flex-end' }}>
                            <Select
                                data={LEADS_OUTCOME}
                                label="Resultado"
                                {...form.getInputProps(`contactAttempts.${index}.outcome`)}
                            />
                        </Grid.Col>
                        {form.values?.contactAttempts[index]?.history && form.values?.contactAttempts[index]?.history?.length > 0 &&
                            <HistoryButtonModal
                                history={form.values?.contactAttempts[index]?.history}
                            />
                        }
                        {form.values?.contactAttempts[index]?.outcome === 'FAILED' && <Grid.Col span={{ base: 12 }}>

                            <TextInput
                                {...form.getInputProps(`contactAttempts.${index}.no_reason`)}
                                label='Razón del fallo'
                                disabled={form.values?.contactAttempts[index]?.outcome !== 'FAILED'}
                            />
                        </Grid.Col>}
                        <Grid.Col span='auto'>
                            <MultiSelect
                                searchable
                                {...form.getInputProps(`contactAttempts.${index}.subject`)}
                                data={academicUnits}
                                label='Consultó por'
                                leftSection={<IconSchool />}
                            />
                        </Grid.Col>
                        {form.values?.contactAttempts[index]?.outcome === 'SUCCESS' && form.values?.contactAttempts[index]?.subject?.length === 1 && <Grid.Col style={{ alignSelf: "flex-end" }} span={3}>
                            <Button
                                disabled={loading}
                                type="submit" onClick={() => {
                                    form.setFieldValue('createSale', form.values?.contactAttempts[index]?.subject[0])
                                    form.setFieldValue('current_seller_id', form.values?.contactAttempts[index]?.seller_id)
                                }} w='100%'>
                                Inscribir usuario
                            </Button>
                        </Grid.Col>
                        }
                        <Grid.Col span={12}>
                            <TextInput
                                {...form.getInputProps(`contactAttempts.${index}.comment`)}
                                label='Comentario'
                            />
                        </Grid.Col>

                    </Grid>
                ))}
            </Grid.Col>

            <Grid.Col span={12}>
                <Button
                    type="submit"
                    className="eventCalendarForm__form__button"
                    loading={loading}
                >
                    Guardar
                </Button>
            </Grid.Col>

        </Grid>
    );
}


const HistoryButtonModal = ({ history }) => {
    const [isModal, setIsModal] = useState(null)
    const text = history?.length === 1 ? "Esta interacción tiene 1 registro antiguo" : `Esta interacción tiene ${history?.length} registro/s antiguos`
    return <>
        <Button leftSection={<IconEye/>} onClick={() => setIsModal(history)} w='100%' justify="flex-start" variant="transparent" color='var(--color-secondary)' style={{ fontSize: "var(--fs-tiny)" }}
        >
            <span>{text}</span>
        </Button>

        <Modal
            opened={isModal}
            onClose={() => setIsModal(null)}
            title='Historial'
            styles={{
                title: {
                    fontSize: '2rem',
                }
            }}
        >
            <Stack>
                {isModal?.map(item => {
                    return <Flex key={item.date} gap={20} w='100%'>
                        <DateInput
                            
                            style={{ flex: 1 }}
                            value={new Date(item.date)}
                            readOnly
                            label="Fecha"
                        />
                        <Select
                            data={LEADS_OUTCOME}
                            label="Resultado"
                            value={item.outcome}
                        />
                    </Flex>
                })}
                <Button onClick={() => setIsModal(null)}>Cerrar</Button>
            </Stack>
        </Modal>
    </>
}